var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loading"}},[_c('PulseLoader',{attrs:{"color":'#303C54',"size":'20px'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }